module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAXBAMAAADw2NLqAAAALVBMVEUAAAAeHh4XFxcZGRkaGhoYGBgZGRkaGhoYGBgZGRkaGhoZGRkZGRkZGRkZGRki3IYZAAAAD3RSTlMAESIzRFVmd4iZqrvM3e5GKvWZAAAAjklEQVQIHQXBvQoBAQAA4I/ze366MpMHMJwX8Awe4AarzagrZVOUTGbbGY1GqduZbCKLxTv4PugMgeT5yyHMSXY4w4bqAcKZXgSFtymLB3uZ8nUwlsrUZ9WdVKZyaU6kVmy/zCUU++TaMQQvtQOES4UPjCLWcEQ3JrijcqE5gYwUdOPgDkq31hhYHwGNE/7T0yG9c/rOfQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/map.png
// module id = 656
// module chunks = 0